import React from 'react';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, TLDR, Qual} from '../common';

// A pretty fundamental problem: refusal to take ACCOUNTABILITY
export const accountability = {
  name: "accountability",
  parentName: <span>our refusal to take <i>accountability</i></span>,
  prelude: <span>
    But <QL name="tm">I<sup>™</sup></QL> am Good<sup>®</sup>. I<sup>™</sup> am a <AL name="you">GoodPerson<sup>™</sup></AL>. I<sup>™</sup> just FollowOrders<sup>™</sup>; I<sup>™</sup> <AL name="notnew.p.arendt">do not <i>choose</i></AL> Evil<sup>®</sup>.
  </span>,
  header: <span>
    Humanity<sup>(®)</sup>-2020’s is allergic to <i>accountability</i>.
  </span>,
  outside: <span>
    It <E2 suffix="s" /> a lot of our <LRL name="gaia">planetary</LRL> problems. (If you’re not just in <PL>denial</PL> about the suffering of ‘<QL>others</QL>’ – the ones the <NW>MNS system</NW> has pushed <PL>out of sight</PL> to <LRL>fuel</LRL> <AL>Omelas</AL>.) Because see, if those problem aren’t my <LRL>fault</LRL> <i><PL name="individuality">personally</PL></i>…
  </span>,
  preview: <div className="problem-preview">
    <p>[Under construction]</p>
  </div>,
//  text: <div className="problem-text">
//    <p></p>
//  </div>,
//  sublist: [],

};
